import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '@mui/material';
export const LeftArrow = props => (_jsx(SvgIcon, { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...props, children: _jsx("path", { d: "M14.3251 18.0002L15.4001 16.9252L10.4501 11.9752L15.4001 7.0252L14.3251 5.9502L8.30015 11.9752L14.3251 18.0002Z", fill: "#49454F" }) }));
